export enum FeaturedMosaicOverlayStrengths {
  Light = 'light',
  Medium = 'medium',
  Strong = 'strong',
}
